// extracted by mini-css-extract-plugin
export default {"slider":"monthlyBillSlider_slider__6qF2C"};